import { createReducer } from '../../commons/redux/createReducer';
import initialState from './NaturezasAto.initialState';
import * as actions from './NaturezasAto.actions';

const fetchNaturezasAto = state => ({
  ...state,
  loading: true,
});

const fetchNaturezasAtoSuccess = (state, action) => ({
  ...state,
  loading: false,
  naturezasAto: action.data,
  error: false,
});

const fetchNaturezasAtoError = (state, action) => ({
  ...state,
  loading: false,
  error: action.error,
});

export const NaturezasAtoReducer = createReducer(initialState, {
  [actions.fetchNaturezasAtoAction().type]: fetchNaturezasAto,
  [actions.fetchNaturezasAtoActionSuccess().type]: fetchNaturezasAtoSuccess,
  [actions.fetchNaturezasAtoActionError().type]: fetchNaturezasAtoError,
});

export default NaturezasAtoReducer;
